import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

import { CONSTANT_VALUES } from '../constants/constant-values';
import { AppService } from '../app.service';
import { HttpInterceptor } from '../shared/index';
import { environment } from '../../environments/environment';
import { Member } from './member';
import { MemberList } from './member-list';
import { CONSTANT_MESSAGES } from '../constants/constants-messages';
import { UtilityFunctions } from '../shared/utility-functions';

@Injectable()
export class MemberService {
  private _appService;
  private utilityFunctions = new UtilityFunctions();
  private memberColoumnName = [];
  private bookingColoumnName = [];
  constructor(private http: HttpInterceptor, private appService: AppService) {
    this._appService = appService;
  }
  /**
   *  Add member from portal
   *
   * @param {MemberList} memberObject
   * @returns
   *
   * @memberOf MemberService
   */
  addMember(memberObject: MemberList) {
    try {
      let url = CONSTANT_VALUES.URL_ADD_MEMBER;
      return new Promise((resolve, reject) => {
        this.http.post(url, memberObject).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }

  addStaff(memberObject: any) {
    try {
      let url = CONSTANT_VALUES.URL_ADD_STAFF;
      return new Promise((resolve, reject) => {
        this.http.post(url, memberObject).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }
  uploadMember(memberObject: MemberList) {
    try {
      let url = CONSTANT_VALUES.URL_UPLOAD_MEMBER;
      return new Promise((resolve, reject) => {
        this.http.post(url, memberObject).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Validate member fields
   *
   * @param {any} member
   * @returns
   *
   * @memberof MemberService
   */
  validationViewSide(member) {
    try {
      let response = {
        status: 200,
        message: ''
      };
      if (member != null) {
        /* if (member.emailId === '') {
             response.status = 203;
             response.message = CONSTANT_MESSAGES.REQUIRE_EMAIL_ID;

             return response;
         }*/
        if (member.contactNumber == null || member.contactNumber === '') {
          response.status = 204;
          response.message = CONSTANT_MESSAGES.REQUIRE_CONTACT_NUMBER;
          return response;
        }
        if (member.membershipId === '') {
          response.status = 205;
          response.message = CONSTANT_MESSAGES.REQUIRE_MEMBERSHIP_ID;
          return response;
        }
      } else {
        response.status = 206;
        response.message = CONSTANT_MESSAGES.REQUIRE_MEMBER_OBJECT;
        return response;
      }
      return response;
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Add multiple member from file
   *
   * @param {any} input
   * @returns
   *
   * @memberOf MemberService
   */
  getMembersFromFile(input) {
    try {
      let that = this;
      let file = input.files[0];
      let lines: any;
      let members = [];
      let lineObj = [];
      let logList = [];
      let validateUploadMemberLog = [];
      let logObj;
      return new Promise((resolve, reject) => {
        if (file && file.name.indexOf('csv') !== -1) {
          let reader = new FileReader();
          reader.onload = function () {
            let text = reader.result;
            lines = text.split(/\r?\n/);
            _.remove(lines, function (record: string) {
              return record.includes(',,,,,,,,');
            });
            lines.forEach(function (line, i) {
              validateUploadMemberLog = [];
              if (line !== '') {
                if (i === 0) {
                  that.memberColoumnName = line.split(',');
                } else {
                  lineObj = line.split(',');
                  let obj = that.createRecord(lineObj);
                  obj.countryCode = obj.countryCode ? '+' + obj.countryCode : '';
                  validateUploadMemberLog = that.utilityFunctions.validateMandatoryFields(obj, members, validateUploadMemberLog);
                  if (validateUploadMemberLog && validateUploadMemberLog.length <= 0) {
                    members.push(obj);
                  } else {
                    logObj = {
                      'obj': obj,
                      'logList': validateUploadMemberLog
                    }
                    logList.push(logObj);
                  }
                  if (i <= (lines.length - 1)) {
                    let result =
                      {
                        'members': members,
                        'logList': logList,
                        'message': ''
                      };
                    resolve(result);
                  }
                }
              } else {
                resolve([]);
              }
            });
          };
          reader.readAsText(file);
        } else {
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  hasMemberWithDuplicateContactNumber(contactNumber, members) {
    return _.find(members, { contactNumber: contactNumber });
  }
  /**
   * Validate member object fields
   *
   * @param {any} rec
   * @param {any} members
   * @returns
   *
   * @memberOf MemberService
   */
  validateMandetoryFields(rec, members) {
    try {
      let validate = true;
      if (!(rec.membershipId + '').trim() || !this.utilityFunctions.validateMemberShipId(rec.membershipId)) {
        validate = false;
      } else if (rec.emailId && !(this.utilityFunctions.validateEmail(rec.emailId))) {
        validate = false;
        // if (!(this.utilityFunctions.validateEmail(rec.emailId))) {
        //     validate = false;
        // }
      } else if (!(rec.countryCode + '').trim()) {
        validate = false;
      } else if (this.utilityFunctions.validateContact(rec.contactNumber) || !(rec.contactNumber + '').trim() ||
        rec.contactNumber.length < 4 || rec.contactNumber.length > 16) {
        validate = false;
      } else if (members && members.length && this.hasMemberWithDuplicateContactNumber(rec.contactNumber, members)) {
        validate = false;
      } else if (!rec.firstName || !(rec.firstName + '').trim()) {
        validate = false;
      } /*else if (!rec.lastName || !(rec.lastName + '').trim()) {
                validate = false;
            } */
      else if (!rec.type || !(rec.type + '').trim()) {
        validate = false;
      }
      return validate;
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Delete member from condo.
   *
   * @param {any} vendorObject
   * @returns
   *
   * @memberOf MemberService
   */
  deleteMember(vendorObject) {
    try {
      let url = CONSTANT_VALUES.URL_DELETE_USER;
      return new Promise((resolve, reject) => {
        this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Disable member for specific facility
   *
   * @param {any} disableMemberObj
   * @returns
   *
   * @memberOf MemberService
   */
  disableMemberForSpecificFacility(disableMemberObj) {
    try {
      let url = CONSTANT_VALUES.URL_DISABLE_MEMBER;
      return new Promise((resolve, reject) => {
        this.http.post(url, disableMemberObj).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Update member details  which are at vendor side
   *
   * @param {any} vendorObject
   * @returns
   *
   * @memberOf MemberService
   */
  updateMember(vendorObject) {
    try {
      let url = CONSTANT_VALUES.URL_UPDATE_MEMBER;
      return new Promise((resolve, reject) => {
        this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }


  /**
   * Update member details  which are at vendor side
   *
   * @param {any} vendorObject
   * @returns
   *
   * @memberOf MemberService
   */
  updateStaff(staffObject) {
    try {
      let url = CONSTANT_VALUES.URL_UPDATE_STAFF;
      return new Promise((resolve, reject) => {
        this.http.put(url, staffObject).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Resend unique code
   *
   * @param {any} vendorObject
   * @returns
   *
   * @memberOf MemberService
   */

  resendMail(vendorObject) {
    try {
      let url = CONSTANT_VALUES.URL_RESEND_CODE;
      return new Promise((resolve, reject) => {
        this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
          console.log(data);
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }

  resendInvite(vendorObject) {
    try {
      let url = CONSTANT_VALUES.URL_RESEND_INVITE;
      return new Promise((resolve, reject) => {
        this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
          console.log(data);
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Deactivate member service call
   *
   * @param {any} vendorObject
   * @returns
   *
   * @memberOf MemberService
   */
  makeDeactive(vendorObject) {
    try {
      let url = CONSTANT_VALUES.URL_DEACTIVATE_USER;
      return new Promise((resolve, reject) => {
        this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Enable members for multiple facility API call
   *
   * @param {any} enableObj
   * @returns
   *
   * @memberOf MemberService
   */
  enableMembers(enableObj) {
    try {
      let url = CONSTANT_VALUES.URL_ENABLE_MEMBER;
      let _userIds = [];
      enableObj.userIds.forEach((userId) => {
        if (typeof userId === 'string') {
          _userIds.push(userId);
        }
      });
      enableObj.userIds = _userIds;
      return new Promise((resolve, reject) => {
        this.http.post(url, enableObj).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Get vendor details
   *
   * @param {any} vendorObject
   * @returns
   *
   * @memberOf MemberService
   */
  getVendorDetails(vendorObject) {
    try {
      let url = CONSTANT_VALUES.URL_GET_VENDOR_BY_ID;
      return new Promise((resolve, reject) => {
        this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Get active member list
   *
   * @param {any} vendorObject
   * @returns
   *
   * @memberOf MemberService
   */
  markActiveToMember(vendorObject) {
    try {
      let url = CONSTANT_VALUES.URL_GET_ACTIVATE_USER;
      return new Promise((resolve, reject) => {
        this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Get deactivate users
   *
   * @param {any} vendorObject
   * @returns
   *
   * @memberOf MemberService
   */
  markDeactiveToMember(vendorObject) {
    try {
      let url = CONSTANT_VALUES.URL_GET_DEACTIVATE_USER;
      return new Promise((resolve, reject) => {
        this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }

  createRecord(record) {
    let obj = {
      membershipId: '',
      firstName: '',
      lastName: '',
      emailId: '',
      countryCode: '',
      contactNumber: '',
      addressLine1: '',
      addressLine2: '',
      note: '',
      type: '',
      groups: []
    };
    if (record && record.length > 0) {
      for (let i = 0; i < record.length; i++) {
        switch (this.memberColoumnName[i]) {
          case 'Membership Id':
            obj.membershipId = record[i] ? record[i] : '';
            break;
          case 'First Name':
            obj.firstName = record[i] ? record[i] : '';
            break;
          case 'Last Name':
            obj.lastName = record[i] ? record[i] : '';
            break;
          case 'Email Id':
            obj.emailId = record[i] ? record[i] : '';
            break;
          case 'Country Code':
            obj.countryCode = record[i] ? record[i] : '';
            break;
          case 'Contact Number':
            obj.contactNumber = record[i] ? record[i] : '';
            break;
          case 'Address Line 1':
            obj.addressLine1 = record[i] ? record[i] : '';
            break;
          case 'Address Line 2':
            obj.addressLine2 = record[i] ? record[i] : '';
            break;
          case 'Notes':
            obj.note = record[i] ? record[i] : '';
            break;
          case 'Type':
            if (record[i]) {
              record[i] = (record[i]).toLowerCase();
              if (obj.type.indexOf(record[i]) < 0) {
                if (obj.type) {
                  obj.type = obj.type.concat(', ');
                }
                obj.type = obj.type.concat(record[i]);
              }
            }
            break;
          case 'Group':
            if (record[i]) {
              if (record[i] && obj.groups.indexOf(record[i])) {
                obj.groups.push(record[i]);
              }
            }

            break;
        }
      }
    }
    console.log(obj);
    return obj
  }

  getBookingsFromFile(input) {
    let that = this;
    let logList = [];
    let file = input.files[0];
    let lines: any;
    let booking = [];
    let validateLog = [];
    let logObj;
    return new Promise((resolve, reject) => {
      if (file && file.name.indexOf('csv') !== -1) {
        let reader = new FileReader();
        reader.onload = function () {
          let text = reader.result;
          lines = text.split(/\r?\n/);
          let array = lines[0].split(',');
          array = array.filter(function (entry) { return entry.trim() != ''; });
          _.remove(lines, function (record: string) {
            return record.includes(',,,,,,,');
          });
          if (lines && lines.length > 0) {
            lines.forEach(function (line, i) {
              if (line !== '' && line !== ',,,,,,,,,,') {
                if (i == 0) {
                  that.bookingColoumnName = line.split(',');
                } else {
                  validateLog = [];
                  let lineObj = line.split(',');
                  let obj = that.createBookingRecord(lineObj);
                  // obj.countryCode = obj.countryCode ? '+' + obj.countryCode : '';
                  let bookingObj = that.utilityFunctions.validateMandatoryFieldsForBookings(obj, validateLog);
                  if (bookingObj.validateLog && bookingObj.validateLog.length <= 0) {
                    booking.push(bookingObj.obj);
                  } else {
                    logObj = {
                      'obj': bookingObj.obj,
                      'logList': bookingObj.validateLog
                    }
                    logList.push(logObj);
                  }
                  if (i <= (lines.length - 1)) {
                    resolve({ booking: booking, loglList: logList, message: '' });
                  }
                }
              } else {
                resolve({});
              }
            });
          }

        };
        reader.readAsText(file);
      } else {
      }
    });
  }

  sendMailToMembers(memberObject: MemberList) {
    let url = CONSTANT_VALUES.URL_SEND_MAIL;
    return new Promise((resolve, reject) => {
      this.http.post(url, memberObject).map((res) => res.json()).subscribe(data => {
        resolve(data);
      });
    });
  }

  uploadBookings(bookingObj) {
    try {
      let url = CONSTANT_VALUES.URL_UPLOAD_BOOKING;
      return new Promise((resolve, reject) => {
        this.http.post(url, bookingObj).map((res) => res.json()).subscribe(data => {
          resolve(data);
        });
      });
    } catch (e) {
      console.log(e);
    }
  }

  createBookingRecord(record) {
    let obj = {
      membershipId: '',
      facilityName: '',
      category: '',
      bookingDate: '',
      startTime: '',
      endTime: '',
      unitName: '',
      title: '',
      attendees: 1

    };
    if (record && record.length > 0) {
      for (let i = 0; i < record.length; i++) {
        switch (this.bookingColoumnName[i]) {
          case 'Membership Id':
            obj.membershipId = record[i] ? record[i] : '';
            break;
          case 'Activity':
            obj.facilityName = record[i] ? record[i] : '';
            obj.title = record[i] ? record[i] : '';
            break;
          case 'Category':
            obj.category = record[i] ? record[i] : '';
            break;
          case 'Booking Date':
            obj.bookingDate = record[i] ? record[i] : '';
            break;
          case 'Start Time':
            obj.startTime = record[i] ? record[i] : '';
            break;
          case 'End Time':
            obj.endTime = record[i] ? record[i] : '';
            break;
          case 'Unit Name':
            obj.unitName = record[i] ? record[i] : '';
            break;
        }
      }
    }
    return obj
  }
}



// WEBPACK FOOTER //
// ./src/app/member/member.service.ts